// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"a1e35cdc","22":"1f3e2187","114":"fcfcd347","787":"1f25e7a4","941":"19e1722f"}[chunkId] + ".chunk.js";
};